<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search"
        >
            <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>Shift Schedule</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>                
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                <template v-slot:activator="{ on, attrs }" v-if="$store.state.currentPagePriv.create">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                      New Shift Schedule
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-divider></v-divider>

                    <v-card-text>
                    <v-container>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <span>Code</span>
                            <v-text-field maxlength="10" v-model="editedItem.code" filled rounded dense hide-details="auto" @keydown.space.prevent :readonly="editedIndex>-1" :rules="reqRule"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Shift Code</span>
                            <v-select filled rounded dense :items="shifts" item-text="code" item-value="code" v-model="editedItem.shift_code" :rules="reqRule"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Outlet Code</span>
                            <v-select filled rounded dense :items="outlets" item-text="name" item-value="code" v-model="editedItem.outlet_code" :rules="reqRule"></v-select>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                            <span>Day</span>
                            <div class="d-flex align-center">
                              <v-checkbox hide-details :value="editedItem.monday" v-model="editedItem.monday" label="Monday"></v-checkbox>
                              <v-checkbox hide-details :value="editedItem.tuesday" v-model="editedItem.tuesday" label="Tuesday"></v-checkbox>
                              <v-checkbox hide-details :value="editedItem.wednesday" v-model="editedItem.wednesday" label="Wednesday"></v-checkbox>
                              <v-checkbox hide-details :value="editedItem.thursday" v-model="editedItem.thursday" label="Thursday"></v-checkbox>
                              <v-checkbox hide-details :value="editedItem.friday" v-model="editedItem.friday" label="Friday"></v-checkbox>
                              <v-checkbox hide-details :value="editedItem.saturday" v-model="editedItem.saturday" label="Saturday"></v-checkbox>
                              <v-checkbox hide-details :value="editedItem.sunday" v-model="editedItem.sunday" label="Sunday"></v-checkbox>
                            </div>
                        </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                        Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                        Save
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="body-1 text-center">Anda akan menghapus Shift ini?</v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDetail" max-width="700px">
                <v-card>
                    <v-card-title class="">
                      <span class="text-h6">Shift Schedule Detail</span>
                      <v-spacer></v-spacer>
                      <v-icon color="white" @click="dialogDetail = false">mdi-close</v-icon>
                    </v-card-title>
                    <v-divider></v-divider>

                    <v-card-text class="pt-4">
                    <v-container>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Code:</v-col>
                          <v-col cols="8">{{ detailItem.code }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Shift Code:</v-col>
                          <v-col cols="8">{{ detailItem.shift_code }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Outlet:</v-col>
                          <v-col cols="8">{{ getOutlateName(detailItem.outlet_code) }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Crew NIK:</v-col>
                          <v-col cols="8">{{ detailItem.crew_nik }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Crew Name:</v-col>
                          <v-col cols="8">{{ detailItem.crew_name }}</v-col>
                        </v-row>
                        <v-divider class="my-3"></v-divider>
                        <v-row>
                          <v-col cols="12" class="font-weight-bold text-h6">Schedule</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-simple-table dense>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">Day</th>
                                    <th class="text-center">Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>Monday</td>
                                    <td class="text-center">
                                      <v-chip x-small :color="detailItem.monday ? 'green' : 'grey'" text-color="white">
                                        {{ detailItem.monday_label || '-' }}
                                      </v-chip>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Tuesday</td>
                                    <td class="text-center">
                                      <v-chip x-small :color="detailItem.tuesday ? 'green' : 'grey'" text-color="white">
                                        {{ detailItem.tuesday_label || '-' }}
                                      </v-chip>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Wednesday</td>
                                    <td class="text-center">
                                      <v-chip x-small :color="detailItem.wednesday ? 'green' : 'grey'" text-color="white">
                                        {{ detailItem.wednesday_label || '-' }}
                                      </v-chip>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Thursday</td>
                                    <td class="text-center">
                                      <v-chip x-small :color="detailItem.thursday ? 'green' : 'grey'" text-color="white">
                                        {{ detailItem.thursday_label || '-' }}
                                      </v-chip>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Friday</td>
                                    <td class="text-center">
                                      <v-chip x-small :color="detailItem.friday ? 'green' : 'grey'" text-color="white">
                                        {{ detailItem.friday_label || '-' }}
                                      </v-chip>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Saturday</td>
                                    <td class="text-center">
                                      <v-chip x-small :color="detailItem.saturday ? 'green' : 'grey'" text-color="white">
                                        {{ detailItem.saturday_label || '-' }}
                                      </v-chip>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Sunday</td>
                                    <td class="text-center">
                                      <v-chip x-small :color="detailItem.sunday ? 'green' : 'grey'" text-color="white">
                                        {{ detailItem.sunday_label || '-' }}
                                      </v-chip>
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-col>
                        </v-row>
                    </v-container>
                    </v-card-text>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogDetail = false">
                        Close
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
            </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="viewDetail(item)">
                mdi-eye
            </v-icon>
            <v-icon small class="mr-2" @click="editItem(item)" v-if="$store.state.currentPagePriv.update">
                mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)" v-if="$store.state.currentPagePriv.delete">
                mdi-delete
            </v-icon>
            </template>
            <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
                Reset
            </v-btn>
            </template>
            <template v-slot:[`item.shift_code`]="{ item }">
              {{getShiftName(item.shift_code)}}
            </template>
            <template v-slot:[`item.outlet_code`]="{ item }">
              {{getOutlateName(item.outlet_code)}}
            </template>
        </v-data-table>
    </div>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      dialogDetail: false,
      detailItem: {},
      headers: [
        { text: 'Crew Nik', value: 'crew_nik' },
        { text: 'Crew Name', value: 'crew_name' },
        { text: 'Outlet Code', value: 'outlet_code' },
        { text: 'Monday', value: 'monday_label' },
        { text: 'Tuesday', value: 'tuesday_label' },
        { text: 'Wednesday', value: 'wednesday_label' },
        { text: 'Thursday', value: 'thursday_label' },
        { text: 'Friday', value: 'friday_label' },
        { text: 'Saturday', value: 'saturday_label' },
        { text: 'Sunday', value: 'sunday_label' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      outlets: [],
      shifts: [],
      editedIndex: -1,
      editedItem: {
        status: true
      },
      defaultItem: {
        status: true
      },
      search: '',
      reqRule: [v => !!v || 'Harus diisi!'],
      valid: true,
      outletCode: []
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Shift' : 'Edit Shift'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      async initialize () {
        try {
          // Load outlets, tapi jika user gak punya akses tetap lanjut
          const outletResponse = await this.$store.dispatch('outlet/getObjs')
          this.outlets = outletResponse.data.data || []
        } catch (error) {
          console.warn('Tidak dapat memuat data outlet:', error)
          this.outlets = []
        }

        try {
          // Load shifts, tapi jika user gak punya akses tetap lanjut
          const shiftResponse = await this.$store.dispatch('shift/getObjs')
          this.shifts = shiftResponse.data.data || []
        } catch (error) {
          console.warn('Tidak dapat memuat data shift:', error)
          this.shifts = []
        }

        // Load shift schedules - ini yang penting
        let response = await this.$store.dispatch('shiftschedule/getObjs')
        if (response.data.status=='success') this.items = response.data.data
      },
      async loadDataTable() {
        let response = await this.$store.dispatch('shiftschedule/getObjs')
        if (response.data.status=='success') this.items = response.data.data
      },

      getShiftName(code) {
        // Jika shifts tidak ada atau kosong, tampilkan code-nya
        if (!this.shifts || this.shifts.length === 0) {
          return code || '-';
        }
        
        const shift = this.shifts.find(element => element.code == code);
        
        // Jika shift ditemukan, tampilkan code. Jika tidak, tampilkan code asli
        return shift ? shift.code : (code || '-');
      },

      getOutlateName(code) {
        if (!code) return '-';
        
        // Jika outlets tidak ada atau kosong, tampilkan code-nya
        if (!this.outlets || this.outlets.length === 0) {
          return code;
        }
        
        const outlet = this.outlets.find(element => element.code == code);
        
        // Jika outlet ditemukan, tampilkan name. Jika tidak, tampilkan code
        return outlet ? outlet.name : code;
      },

      viewDetail(item) {
        this.detailItem = Object.assign({}, item);
        this.dialogDetail = true;
      },
      
      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      async deleteItemConfirm () {
        let url = this.$store.state.config.apiHost + "shift-schedules/" + this.editedItem.code
        let response = await this.$axios.delete(url, {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
        if (response.data.status=='success') this.items.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async save () {
        await this.$refs.form.validate();
        if (!this.valid) return;

        if (this.editedIndex > -1) {
          let url = this.$store.state.config.apiHost + "shift-schedules/" + this.editedItem.code
          let response = await this.$axios.put(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
          if (response.data.status == 'success') {
            Object.assign(this.items[this.editedIndex], this.editedItem)

            this.loadDataTable()
          }
          this.close()
          
        } else {
          try {
            let url = this.$store.state.config.apiHost + "shift-schedules"
            let response = await this.$axios.post(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
            if (response.data.status=='success'){
              this.items.push(this.editedItem)
              this.loadDataTable()
            }

            this.close()
          }
          catch (err) {
            const keyword = 'duplicate key'
            if (err.response.data.message.search(keyword) > -1){
              return this.$store.commit('setSnackbar', {saveError: true, errorMessage: "Duplicate Key! Kode sudah terpakai."})
            }
            else {
              return this.$store.commit('setSnackbar', {saveError: true, errorMessage: err.response.data.message})
            }
          }

        }
      },
    },
  }
</script>

<style>
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
    border-radius: 7px!important;
}

</style>